import { Modal, Paper, Typography } from '@material-ui/core';
import Alert from 'components/Alert';
import { Formik, Form } from 'formik';
import { functions } from 'helpers';
import React, { memo, useCallback } from 'react';
import { toast } from 'react-toastify';
import affiliateService from 'v2/services/affiliate';

import type { IAffiliate } from 'v2/interfaces/affiliate';

import FormCommision from './FormCommision';
import styles from './styles';
import IFormCommisionSchema from './validations';

import type { IFormCommision } from './interfaces';
import type { FormikProps } from 'formik';

interface IProps {
  open: boolean;
  handleClose: Function;
  affiliate: IAffiliate;
}

let InitialValues = {
  active: false,
  type: 'P',
  value: '',
};

const CustomCommissionForm = ({ open, handleClose, affiliate }: IProps) => {
  const classes = styles({});

  const onSubmit = useCallback(
    async (values: IFormCommision, { setSubmitting }: FormikProps<IFormCommision>) => {
      setSubmitting(true);

      if (!values.active) {
        affiliateService.configCustomCommission(affiliate.id).subscribe(
          () => {
            toast.success('Comissão diferenciada configurada com sucesso!');
            setSubmitting(false);
            handleClose();
          },
          () => {
            toast.error('Erro ao configurar comissão, verifique se o valor da comissão não é maior que o valor do produto');
            setSubmitting(false);
          }
        );
        return;
      }

      if (values.active && !values.value) {
        toast.error(`Insira ${values.type === 'P' ? 'a porcentagem' : 'o valor'}`);
        setSubmitting(false);
        return;
      }

      let cleanValue = Number.parseFloat(functions.clearMoneyMask(values.value));

      if (values.type === 'V') {
        const confirmation = await Alert.show({
          title: 'Atenção',
          message:
            'Verifique se há cupons de desconto cadastrado para esse produto. Caso a comissão diferenciada seja maior que o valor do produto com desconto o pagamento de seus afiliados e coprodutores será afetado.',
          confirmation: true,
          buttonOk: 'Salvar comissão',
          buttonCancel: 'Cancelar',
        });

        if (!confirmation) {
          return;
        }
      }
      affiliateService.configCustomCommission(affiliate.id, values.type, cleanValue).subscribe(
        () => {
          toast.success('Comissão diferenciada configurada com sucesso!');
          setSubmitting(false);
          handleClose();
        },
        () => {
          toast.error('Erro ao configurar comissão, verifique se o valor da comissão não é maior que o valor do produto');
          setSubmitting(false);
        }
      );
    },
    [affiliate, handleClose]
  );

  return (
    <Modal open={open} onClose={() => handleClose()}>
      <Paper elevation={10} className={classes.paper}>
        <Typography variant='h6'>Comissão diferenciada</Typography>

        <div className='m8' />

        <div>Ao habilitar esta opção a comissão do afiliado selecionado irá sobrepor as configurações pré-definidas no cadastro do seu produto.</div>

        <div className='m8' />

        <Formik initialValues={InitialValues} validationSchema={IFormCommisionSchema} onSubmit={onSubmit}>
          {() => (
            <Form>
              <FormCommision affiliate={affiliate} handleClose={handleClose} />
            </Form>
          )}
        </Formik>
      </Paper>
    </Modal>
  );
};

export default memo(CustomCommissionForm);
